import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import BracketingWidgetConfiguration from './BracketingWidgetConfiguration/BracketingWidgetConfiguration'
import BracketingWidgetConfigurationPageSkeleton from './BracketingWidgetConfigurationPageSkeleton/BracketingWidgetConfigurationPageSkeleton'
import useBracketingWidgetConfiguration from './hooks/useBracketingWidgetConfiguration/useBracketingWidgetConfiguration'
import * as Styles from './styles'

const BracketingWidgetConfigurationPage = () => {
  const { info } = useContext(AppContext)
  const { hasPermission } = useUserPermissions()
  const { setToastInfo } = useContext(ToastContext)
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']

  const {
    gettingBracketingWidgetPreferences,
    applyingBracketingWidgetPreferences,
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    linkColor,
    setLinkColor,
    customTexts,
    setCustomTexts,
    useCustomTitle,
    setUseCustomTitle,
    useCustomContent,
    setUseCustomContent,
    useSizeGuide,
    setUseSizeGuide,
    hasChanges,
    revertChanges,
    scriptInfo,
    onSave,
  } = useBracketingWidgetConfiguration({
    storeId: info.selectedStore.id,
    setToastInfo,
    supportedLanguages,
  })

  if (gettingBracketingWidgetPreferences) {
    return <BracketingWidgetConfigurationPageSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editExtra)} />}
      <BracketingWidgetConfiguration
        backgroundColor={backgroundColor}
        onChangeBackgroundColor={setBackgroundColor}
        textColor={textColor}
        onChangeTextColor={setTextColor}
        linkColor={linkColor}
        onChangeLinkColor={setLinkColor}
        customTexts={customTexts}
        onChangeCustomTexts={setCustomTexts}
        useCustomTitle={useCustomTitle}
        onChangeUseCustomTitle={setUseCustomTitle}
        useCustomContent={useCustomContent}
        onChangeUseCustomContent={setUseCustomContent}
        useSizeGuide={useSizeGuide}
        onChangeUseSizeGuide={setUseSizeGuide}
        supportedLanguages={supportedLanguages}
        scriptInfo={scriptInfo}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editExtra) && hasChanges}
        onSave={onSave}
        onRevertChanges={revertChanges}
        loading={applyingBracketingWidgetPreferences || gettingBracketingWidgetPreferences}
        disabled={applyingBracketingWidgetPreferences || gettingBracketingWidgetPreferences}
      />
    </Styles.Container>
  )
}

export default BracketingWidgetConfigurationPage
